<script lang="ts">
	import { Lightshow, Scene } from "luxedo-data"
	import ShowPreviewLightshow from "./ShowPreview_Lightshow.svelte"
	import { ShowOverviewController } from "../ShowOverviewController"
	import { ShowPreviewVideo } from "luxedo-comps"
	import { ArrowBack } from "luxedo-icons"

	let show: Scene | Lightshow = $state()
	let isOpen = $state(false)

	ShowOverviewController.subscribe((ctx) => {
		show = ctx.show
		isOpen = ctx.isPreviewing
	})
</script>

<div class="video-player {isOpen ? 'open' : ''}">
	<button class="icon" onclick={ShowOverviewController.hideVideoPlayer}><ArrowBack /> Back</button>

	{#if show instanceof Scene}
		<ShowPreviewVideo src={show.src.preview} {isOpen} />
	{:else if show instanceof Lightshow}
		<ShowPreviewLightshow {show} {isOpen} />
	{/if}
</div>

<style>
	.video-player {
		z-index: 100;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 0rem;
		background-color: var(--color-bg-dark);
		overflow: hidden;
		transition: height;
		transition-duration: 750ms;
		transition-delay: 0ms;
	}

	.video-player.open {
		transition-delay: 250ms;
		height: 80vh;
	}

	:global(.isMobile) .video-player.open {
		height: 95dvh;
	}

	.video-player :global(video) {
		width: 100%;
		height: 100%;
	}

	button {
		color: var(--color-text);
		padding: 1rem 1rem;
		z-index: 1;
		position: absolute;
		top: 0;
		left: 0;
		/* padding: ; */
	}

	button :global(svg) {
		height: 1.5rem;
		width: 2rem;
	}

	button :global(.svg-stroke) {
		stroke: var(--color-text);
	}

	button:focus-visible :global(.svg-stroke),
	button:hover :global(.svg-stroke) {
		stroke: var(--color-main);
	}

	button:focus-visible,
	button:hover {
		color: var(--color-main);
	}
</style>
